package com.loyola.acessoescola.ui.login

enum class AppRoles(val appRole: String) {
    ALUNO("Alunos.Edit"),
    ADMIN("Admin.Edit")
}